export default {"src":"/_next/static/media/Settings.765e476c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};